import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { InvoiceItem } from './models/invoice-item.model';
import { catchError, Observable } from 'rxjs';
import { ResultSet } from '../../shared/models/result-set.model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceItemService extends ApiService<InvoiceItem> {

  override readonly _baseUrl: string;

  override readonly searchFields: string[] = [];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}invoices/items/`;
  }  

  getItemsByInvoiceId(invoiceId: number, offset: number = 0, limit: number=10): Observable<ResultSet<InvoiceItem>> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString());
    return this.http.get<ResultSet<InvoiceItem>>(`${this._baseUrl}for-invoice/${invoiceId}`, { params }).pipe(
      catchError(this.handleError)
    );
  } 
}
